class HideBanner extends HTMLElement {
  constructor() {
    super();

    if (sessionStorage.getItem('hideBanner') == 'true') {
      this.setAttribute("aria-hidden", "true")
    }
  }

  connectedCallback() {
    this.querySelector('.js-hide-banner').addEventListener('click', () => {
      sessionStorage.setItem('hideBanner', 'true')
      this.setAttribute("aria-hidden", "true")
    })
  }
}

if (!customElements.get("hide-banner")) {
  customElements.define('hide-banner', HideBanner);
}